export const version = "4.0.4";
export const build = "esm";
//# sourceMappingURL=version.js.map
